// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8c6c1bbe","722":"57d3ed6e"}[chunkId] + ".chunk.js";
};